function isV4Result(result: FingerprintAgentResult): result is FingerprintAgentResultV4 {
  return 'event_id' in result || 'sealed_result' in result || 'visitor_id' in result;
}

/**
 * Maps a Fingerprint JS agent `get()` result (v3 or v4) to the `requestId` / `sealedResult` pair the
 * rest of the package (and the backend contract: `df_pro_request_id` / `df_pro_sealed_result`) uses.
 *
 * - v3: `{ requestId, sealedResult }` (sealedResult is already a base64 string)
 * - v4: `{ event_id, sealed_result }` (sealed_result is a `BinaryOutput | null` and must be serialized)
 *
 * Missing values are returned as empty strings.
 */
export function parseAgentResult(result: FingerprintAgentResult | undefined): {
  requestId: string;
  sealedResult: string;
} {
  if (!result) {
    return { requestId: '', sealedResult: '' };
  }

  if (isV4Result(result)) {
    return {
      requestId: result.event_id ?? '',
      sealedResult: result.sealed_result?.base64() ?? '',
    };
  }

  return {
    requestId: result.requestId ?? '',
    sealedResult: result.sealedResult ?? '',
  };
}

/** Returns the visitor ID from a v3 (`visitorId`) or v4 (`visitor_id`) `get()` result. */
export function getAgentVisitorId(result: FingerprintAgentResult | undefined): string {
  if (!result) {
    return '';
  }
  return (isV4Result(result) ? result.visitor_id : result.visitorId) ?? '';
}
